import { FC, useEffect, useState } from 'react';

import homecook_logo from '../../assets/img/homecook_logo.png';
import { isBetaHost } from '../../utils/betaHost';
import { PARTNER_LINKS, PARTNER_SECTION_IDS } from './partnerContent';

type UnauthHeaderProps = {
  /** Hide in-page anchors on pages that do not render the marketing sections. */
  showNav?: boolean;
};

const NAV_ITEMS = [
  { label: 'What you can list', href: `#${PARTNER_SECTION_IDS.value}` },
  { label: 'How it works', href: `#${PARTNER_SECTION_IDS.how}` },
  { label: 'Why HomeCook', href: `#${PARTNER_SECTION_IDS.impact}` },
];

/** Sticky logged-out header with brand, marketing anchors, and the demo call to action. */
export const UnauthHeader: FC<UnauthHeaderProps> = ({ showNav = true }) => {
  const [isBeta, setIsBeta] = useState(false);

  useEffect(() => {
    setIsBeta(isBetaHost());
  }, []);

  return (
    <header className="sticky top-0 z-30 border-b border-[#E4EEF1] bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-[72px] w-full max-w-[1450px] items-center justify-between gap-4 px-6 lg:px-12">
        <a href={PARTNER_LINKS.publicSite} className="flex min-w-0 items-center gap-2">
          <img src={homecook_logo} alt="HomeCook" className="h-11 w-11 object-contain" />
          <span className="truncate font-raleway text-xl font-bold text-ink">Partner Dashboard</span>
          {isBeta ? (
            <span className="ml-1 rounded-full bg-gradient-to-r from-primary-400 to-primary-300 px-2 py-0.5 font-open-sans text-[11px] font-semibold tracking-wide text-white shadow-sm">
              BETA
            </span>
          ) : null}
        </a>

        {showNav ? (
          <nav aria-label="Partner Dashboard sections" className="hidden items-center gap-7 lg:flex">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="font-open-sans text-sm font-semibold text-[#3F5B64] transition-colors hover:text-primary-300"
              >
                {item.label}
              </a>
            ))}
          </nav>
        ) : null}

        <div className="flex items-center gap-3">
          {showNav ? (
            <a
              href={`#${PARTNER_SECTION_IDS.auth}`}
              className="hidden font-open-sans text-sm font-semibold text-primary-100 hover:text-primary-300 sm:inline"
            >
              Sign in
            </a>
          ) : null}
          <a
            href={PARTNER_LINKS.bookDemo}
            target="_blank"
            rel="noreferrer"
            className="inline-flex h-10 items-center rounded-lg bg-primaryDark-0 px-4 font-raleway text-sm font-semibold text-white transition-colors hover:bg-primary-300"
          >
            Book a demo
          </a>
        </div>
      </div>
    </header>
  );
};

export default UnauthHeader;
